module.exports = {"530627001":"乌峰街道","530627002":"南台街道","530627003":"旧府街道","530627102":"泼机镇","530627103":"黑树镇","530627104":"母享镇","530627105":"大湾镇","530627106":"以勒镇","530627107":"赤水源镇","530627108":"芒部镇","530627109":"雨河镇","530627110":"罗坎镇","530627111":"牛场镇","530627112":"五德镇","530627113":"坡头镇","530627114":"以古镇","530627115":"场坝镇","530627116":"塘房镇","530627117":"中屯镇","530627118":"木卓镇","530627119":"盐源镇","530627120":"碗厂镇","530627121":"坪上镇","530627202":"鱼洞乡","530627203":"花朗乡","530627204":"尖山乡","530627208":"杉树乡","530627209":"花山乡","530627211":"果珠彝族乡","530627212":"林口彝族苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530627.json
// module id = 2586
// module chunks = 0